module.exports = "query chancelleries{chancelleries{list{id iban hasB2B}}}"